import { Button, Layout } from "antd";
import styled from "styled-components";

import colors, { foundationColors, systemColors } from "../../../themes/colors";

export const AntLayout = styled(Layout)`
  position: fixed;
  width: 100vw;
  height: 100vh;

  // LeftNavigation
  .ant-menu {
    border-right: none;
    color: ${foundationColors["base-deep-purple"]};
    background-color: rgb(250, 250, 250);
  }
  .ant-menu-submenu {
    padding: 8px 0px;
  }
  .ant-menu-submenu-title {
    text-transform: uppercase;
    font-weight: bold;
    font-size: 12px;
    color: ${foundationColors["base-deep-purple"]};

    &:hover,
    &:active,
    &.ant-menu-submenu-title-active,
    &.ant-menu-submenu-title-selected {
      color: ${foundationColors["base-deep-purple"]};
    }
  }

  .ant-menu-item {
    &:hover {
      background-color: ${colors.lightestGray};
      color: ${foundationColors["base-deep-purple"]};
    }

    &.ant-menu-item-selected {
      background-color: ${foundationColors["coral-200"]};
    }
  }

  // LeftNavigation - handles icons ui changes when the navigation is in 'collapsed' state
  .ant-layout-sider-collapsed {
    .arrow {
      transform: rotate(180deg);
    }
    .smarta-logo {
      opacity: 0;
    }
  }
  // Force navigation item text to always be base-deep-purple in all states
  .ant-menu-item a,
  .ant-menu-item-selected a,
  .ant-menu-item-active a,
  .ant-menu-item a:hover,
  .ant-menu-item a.active {
    color: ${foundationColors["base-deep-purple"]};
  }
`;

export const IconMenuButton = styled(Button)`
  background-color: ${foundationColors["deep-purple-200"]};
  border: none;

  :hover,
  :active,
  :focus {
    background-color: ${foundationColors["deep-purple-100"]};
    color: ${foundationColors["base-deep-purple"]};
    border-color: ${foundationColors["base-deep-purple"]};
  }

  &.ant-btn:focus {
    background-color: ${foundationColors["deep-purple-100"]};
    border-color: ${foundationColors["base-deep-purple"]};
  }

  .anticon,
  .anticon-double-left {
    color: ${foundationColors["base-deep-purple"]};
  }
`;

export const MenuHeader = styled.div<{ isStaging: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${({ isStaging }) =>
    isStaging ? colors.veryLightCyan : colors.lightestEverGray};
  border-bottom: 1px solid
    ${({ isStaging }) => (isStaging ? colors.lightCyan : colors.antiFlashWhite)};
  height: 64px;
  position: sticky;
  top: 0;
  z-index: 999;

  .smarta-logo {
    position: absolute;
    left: 16px;
    top: 29px;
    transform: translateY(-50%);
    z-index: 0;
    opacity: 1;
    transition: opacity 300ms;
    ${({ isStaging }) => isStaging && `path { fill: ${colors.cyan}}`}
  }

  .arrow {
    position: absolute;
    right: 16px;
    top: 20px;
    z-index: 1;
    transition: transform 0s 300ms ease-in-out;

    :focus {
      outline-style: solid;
      outline-width: 1px;
    }

    ${({ isStaging }) =>
      isStaging &&
      `
    background: ${systemColors["semantic-green-100"]};
    :hover,
    :active,
    :focus {
      background-color: ${systemColors["semantic-green-100"]};
    }
    `}
  }
`;

export const HeadSiderTitle = styled.div`
  margin-left: 48px;
  font-size: 19px;
  line-height: 24px;
  color: ${colors.cyan};
  letter-spacing: 0.02em;
`;
